import React from 'react';
import { Route, Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import Layout from '../layout/Layout';

const ProtectedRoute = () => {
  const { user } = useAuth();

  return (
    user ? (
      <Layout>
        <Outlet />
      </Layout>
    ) : (
      <Navigate to="/login" replace />
    )
  );
};

export default ProtectedRoute;
